import { Outlet } from 'react-router-dom';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { BlockAppHeader } from './blocks/AppHeader';
import { BlockConditionalRendering } from './blocks/ConditionalRendering';
import { BlockDetails } from './blocks/Details';
import { BlockEmptyContent } from './blocks/EmptyContent';
import { BlockFilters } from './blocks/Filters';
import { BlockHeaderControls } from './blocks/HeaderControls';
import { BlockItems } from './blocks/Items';
import { BlockNotAuthorized } from './blocks/NotAuthorized';
import { BlockSide } from './blocks/Side';
import { BlockSlider } from './blocks/Slider';
import { BlockSpacer } from './blocks/Spacer';
import { BlockTagsFilters } from './blocks/Tags';
export const BlockWrapper = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => !['withShadow'].includes(prop),
})
    .attrs(() => ({
    display: 'block',
})) `
    ${({ theme, withShadow }) => withShadow
    ? `box-shadow: 0 6px 6px -6px ${theme.themeVariables.frameDropShadow};`
    : null};

    &:empty {
      ${({ $emptyStyle }) => $emptyStyle}
    }
  `;
export const BLOCKS = {
    appHeader: {
        id: 'block-app-header',
        component: BlockAppHeader,
    },
    headerControls: {
        id: 'block-header-controls',
        component: BlockHeaderControls,
    },
    filters: {
        id: 'block-filters',
        component: BlockFilters,
    },
    tags: {
        id: 'block-tags',
        component: BlockTagsFilters,
    },
    items: {
        id: 'block-items',
        component: BlockItems,
    },
    emptyContent: {
        id: 'block-empty-content',
        component: BlockEmptyContent,
    },
    conditionalRendering: {
        id: 'block-conditional',
        component: BlockConditionalRendering,
    },
    details: {
        id: 'block-details',
        component: BlockDetails,
    },
    slider: {
        id: 'block-slider',
        component: BlockSlider,
    },
    outlet: {
        id: 'outlet',
        component: Outlet,
    },
    side: {
        id: 'block-side',
        component: BlockSide,
    },
    spacer: {
        id: 'spacer',
        component: BlockSpacer,
    },
    notAuthorized: {
        id: 'not-authorized',
        component: BlockNotAuthorized,
    },
};
//# sourceMappingURL=shared.js.map